// src/shared/content/default-bundle.ts — build-baked fallback ContentBundle (D-22).
//
// Hand-authored JSON at default-bundle.json is the single source of truth.
// Boot-time ContentBundleSchema.parse catches drift between JSON and schema.
// After P5 Plan 08: the original Pitfall 8 parity guard (DEFAULT_BUNDLE vs
// legacy PROFILES + ADULT_COMMENTARY records) has been retired — those
// records no longer exist. A smaller structural guard lives in
// __tests__/default-bundle.test.ts covering the invariants downstream
// consumers rely on (schemaVersion, roster size, locked-count, quote/tag
// coverage).
//
// Source: .planning/phases/05-content-pipeline-characters-admin-cms/05-CONTEXT.md D-22;
// 05-08-PLAN.md Pitfall 1 cleanup.

import bundleJson from './default-bundle.json';
import { ContentBundleSchema } from './schema';
import type { ContentBundle } from './types';

// Parse at module load so a malformed edit fails fast in dev + CI rather
// than at the first fetch-fallback path on a live family device.
export const DEFAULT_BUNDLE: ContentBundle = ContentBundleSchema.parse(bundleJson);
